import { InjectionToken } from '@angular/core';
import type { BidRelevanceConfig } from './bid-relevance.interface';

export const BID_RELEVANCE_CONFIG = new InjectionToken<BidRelevanceConfig>(
  'BidRelevanceConfig',
);
